import { request } from '@lib/request';

export function getApplicantInfo() {
    return request({
        method: 'get',
        url: '/api/funder',        
    });
}

export function updateApplicantInfo(applicantData: any) {
    return request({
        method: 'put',
        url: '/api/funder/profile',
        data: applicantData
    });
}

export function acceptApplicantProfile() {
    return request({
        method: 'put',
        url: '/api/funder/accept-profile',
    });
}